import { useEffect, useState } from "react";
import { api } from "./api";

let scriptPromise = null;

function loadSnap(clientKey, isProd) {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    if (window.snap) return resolve(window.snap);
    const s = document.createElement("script");
    s.src = isProd ? "https://app.midtrans.com/snap/snap.js" : "https://app.sandbox.midtrans.com/snap/snap.js";
    s.setAttribute("data-client-key", clientKey);
    s.onload = () => resolve(window.snap); s.onerror = reject;
    document.body.appendChild(s);
  });
  return scriptPromise;
}

export function useMidtrans() {
  const [cfg, setCfg] = useState({ configured: false, client_key: "", is_production: false });
  useEffect(() => { api.get("/midtrans/config").then(r => setCfg(r.data)).catch(()=>{}); }, []);

  const paySnap = async ({ plan_id, order_id, onSuccess, onPending, onError, onClose }) => {
    if (!cfg.configured) throw new Error("Midtrans belum dikonfigurasi");
    const r = await api.post("/midtrans/snap", { plan_id, order_id });
    await loadSnap(r.data.client_key || cfg.client_key, cfg.is_production);
    window.snap.pay(r.data.token, {
      onSuccess: (result) => onSuccess?.(result, r.data.order_id),
      onPending: (result) => onPending?.(result, r.data.order_id),
      onError:   (result) => onError?.(result, r.data.order_id),
      onClose:   () => onClose?.(r.data.order_id),
    });
    return r.data;
  };

  return { midtrans: cfg, paySnap };
}
